




































































































































































































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator'
import HeadLable from '@/components/HeadLable/index.vue'
import InputAutoComplete from '@/components/InputAutoComplete/index.vue'
import TabChange from './tabChange.vue'
import Empty from '@/components/Empty/index.vue'
import {
  getOrderDetailPage,
  queryOrderDetailById,
  completeOrder,
  deliveryOrder,
  orderCancel,
  orderReject,
  orderAccept,
  getOrderListBy,
  assignGoons,
  getOrderPrizeInfo,
  deliverPrize,
  cancelPrize,
  rejectOrder
} from '@/api/order'
import { getGoonsList } from '@/api/goons'

@Component({
  components: {
    HeadLable,
    InputAutoComplete,
    TabChange,
    Empty,
  },
})
export default class extends Vue {
  private defaultActivity: any = 0
  private orderStatics = {}
  private row: any = {}
  private isAutoNext = true
  private isTableOperateBtn = true
  private currentPageIndex = 0 //记录查看详情数据的index
  private orderId = '' //订单号
  private input = '' //搜索条件的订单号
  private phone = '' //搜索条件的手机号
  private valueTime = []
  private dialogVisible = false //详情弹窗
  private dialogOrderStatus = 0 //弹窗所需订单状态，用于详情展示字段
  private counts: number = 0
  private page: number = 1
  private pageSize: number = 10
  private tableData: any[] = []
  private diaForm: any = {}
  private isSearch: boolean = false
  private orderStatus = 0 //列表字段展示所需订单状态,用于分页请求数据
  private prizeOrder: any = null // 奖品订单信息
  // 新增员工选择相关字段
  private goonsDialogVisible = false // 员工选择弹窗可见性
  private goonsList = [] // 员工列表
  private selectedGoons = null // 当前选中的员工
  private currentOrder = null // 当前处理的订单
  private _throttleTimer: any = null // 节流定时器
  private completeDialogVisible = false // 完成订单弹窗可见性
  private completeOrderData = null // 当前要完成的订单数据
  private orderList = [
    {
      label: '全部订单',
      value: 0,
    },
    {
      label: '待付款',
      value: 1,
    },
    {
      label: '待接单',
      value: 2,
    },
    {
      label: '服务中',
      value: 3,
    },
    {
      label: '待结单',
      value: 4,
    },
    {
      label: '已完成',
      value: 5,
    },
    {
      label: '售后中',
      value: 6,
    },
    {
      label: '充值订单',
      value: 7,
    },
    {
      label: '抽奖订单',
      value: 8,
    },
    {
      label: '打赏订单',
      value: 9,
    },
  ]

  created() {
    this.init(Number(this.$route.query.status) || 0)
  }

  mounted() {
    //如果有值说明是消息通知点击进来的
    if (
      this.$route.query.orderId &&
      this.$route.query.orderId !== 'undefined'
    ) {
      this.goDetail(this.$route.query.orderId, 2)
    }
    if (this.$route.query.status) {
      this.defaultActivity = this.$route.query.status
    }
    
    // 强制刷新订单列表，确保获取最新数据
    console.log('页面加载完成，强制刷新订单列表')
    this.page = 1
    this.init(this.orderStatus || 0, true)
    
    // console.log(this.$route.query, 'this.$route')
  }

  initFun(orderStatus) {
    this.page = 1
    this.init(orderStatus)
  }

  change(activeIndex) {
    if (activeIndex === this.orderStatus) return
    this.init(activeIndex)
    this.input = ''
    this.phone = ''
    this.valueTime = []
    this.dialogOrderStatus = 0
    this.$router.push('/order')
    console.log(activeIndex, '接收到了子组件的index')
  }

  //获取待处理，待派送，派送中数量
  getOrderListBy3Status() {
    // 避免频繁请求，添加节流
    if (this._throttleTimer) {
      clearTimeout(this._throttleTimer)
    }
    
    this._throttleTimer = setTimeout(() => {
      // 添加时间戳参数，确保不使用缓存
      getOrderListBy({ timestamp: Date.now() })
        .then((res: any) => {
          if (res.data.code === 1) {
            // 获取基本订单统计
            this.orderStatics = res.data.data
            console.log('订单统计数据更新成功:', this.orderStatics)
            
            // 统计充值订单和抽奖订单数量
            this.countSpecialOrders()
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch((err) => {
          this.$message.error('请求出错了：' + err.message)
        })
    }, 300) // 300ms的节流时间
  }

  // 统计充值订单和抽奖订单数量
  countSpecialOrders() {
    // 获取所有订单，不分页，只取必要字段
    const params = {
      page: 1,
      pageSize: 1000, // 获取足够多的订单以进行统计
      status: undefined // 不限制状态
    }

    getOrderDetailPage({ ...params })
      .then((res) => {
        if (res.data.code === 1) {
          const allOrders = res.data.data.records || []
          
          // 统计充值订单数量
          const rechargeOrders = allOrders.filter(item => 
            item.remark && item.remark.includes('充值')
          ).length
          
          // 统计抽奖订单数量
          const drawOrders = allOrders.filter(item => 
            (item.remark && item.remark.includes('抽奖')) || 
            (item.drawId && item.drawId > 0)
          ).length
          
          // 更新订单统计
          this.orderStatics = {
            ...this.orderStatics,
            rechargeOrders,
            drawOrders
          }
          
          console.log('更新后的订单统计:', this.orderStatics)
        }
      })
      .catch((err) => {
        console.error('统计特殊订单出错:', err)
      })
  }

  async init(status: number, isSearch?: boolean) {
    this.orderStatus = status
    this.isSearch = isSearch
    const params: {
      page: number;
      pageSize: number;
      status: number | undefined;
      number?: string;
      phone?: string;
      beginTime?: string;
      endTime?: string;
      orderType?: 'recharge' | 'draw' | 'tip';
      excludeSpecialOrders?: boolean;
    } = {
      page: this.page,
      pageSize: this.pageSize,
      status: status === 0 ? undefined : status,
      number: this.input ? this.input : undefined,
      phone: this.phone ? this.phone : undefined,
      beginTime: this.valueTime ? this.valueTime[0] : undefined,
      endTime: this.valueTime ? this.valueTime[1] : undefined
    }

    // 添加特殊订单类型的查询逻辑
    if (status === 7) { // 充值订单
      params.orderType = 'recharge'
      params.status = undefined
    } else if (status === 8) { // 抽奖订单
      params.orderType = 'draw'
      params.status = undefined
    } else if (status === 9) { // 打赏订单
      params.orderType = 'tip'
      params.status = undefined
    } else if (status === 0) { // 全部订单
      // 在全部订单中排除特殊订单
      params.excludeSpecialOrders = true
    }
    // 在其他状态(1-6)中不设置 excludeSpecialOrders，让抽奖订单也能显示

    try {
      const res = await getOrderDetailPage(params)
      if (res.data.code === 1) {
        // 根据订单状态进行过滤
        if (status === 8) {
          // 在抽奖订单标签页下，只显示drawId不为空且不是奖品订单的订单
          this.tableData = res.data.data.records.filter(order => 
            order.drawId && 
            (!order.remark || !order.remark.includes('奖品ID:'))
          )
        } else {
          this.tableData = res.data.data.records
        }
        this.counts = res.data.data.total
      } else {
        this.$message.error(res.data.msg || '查询失败')
      }
    } catch (err) {
      this.$message.error('请求出错了：' + err.message)
    }
  }

  // 查看详情
  async goDetail(id: any, status: number, row?: any) {
    this.diaForm = {}
    this.prizeOrder = null // 重置奖品订单信息
    this.dialogVisible = true
    this.dialogOrderStatus = status
    this.orderId = id
    
    try {
      // 获取订单详情
      const { data } = await queryOrderDetailById({ orderId: id })
      if (data.code === 1 && data.data) {
        const orderData = data.data
        console.log('订单详情原始数据:', orderData)
        
        // 设置基本订单信息
        this.diaForm = {
          id: orderData.id,
          number: orderData.number,
          consignee: orderData.consignee,
          phone: orderData.phone,
          drawId: orderData.drawId,
          goodsId: orderData.goodsId,
          goodsName: orderData.goodsName,
          goodsImage: orderData.goodsImage,
          goodsDescription: orderData.goodsDescription,
          price: orderData.price,
          amount: orderData.amount,
          orderTime: orderData.orderTime,
          payTime: orderData.payTime,
          acceptTime: orderData.acceptTime,
          finishTime: orderData.finishTime,
          payMethod: orderData.payMethod,
          goonsId: orderData.goonsId,
          goonsName: orderData.goonsName,
          gameId: orderData.gameId,
          gamePlatform: orderData.gamePlatform,
          remark: orderData.remark,
          hasPrize: orderData.hasPrize || false,
          prizeOrderId: orderData.prizeOrderId, // 使用正确的奖品订单ID
          prizeOrderStatus: orderData.prizeOrderStatus // 添加奖品订单状态
        }
        
        // 如果是抽奖订单且已抽奖，设置奖品信息
        if (this.diaForm.drawId && this.diaForm.hasPrize && orderData.drawPrize) {
          this.prizeOrder = {
            id: orderData.drawPrize.id,
            goodsName: orderData.drawPrize.name,
            amount: orderData.drawPrize.price,
            description: orderData.drawPrize.description,
            image: orderData.drawPrize.image,
            status: orderData.prizeOrderStatus || orderData.drawPrize.status, // 使用奖品订单状态
            originalPrice: orderData.drawPrize.originalPrice
          }
        }
        
        console.log('处理后的订单详情数据:', this.diaForm)
        console.log('奖品订单信息:', this.prizeOrder)
      } else {
        this.diaForm = {}
        this.$message.error(data.msg || '获取订单详情失败')
      }
    } catch (err) {
      console.error('获取订单详情失败:', err)
      this.$message.error('获取订单详情失败')
    }
    
    this.row = row || { id: this.$route.query.orderId, status }
    if (this.$route.query.orderId) {
      this.$router.push('/order')
    }
  }

  // 显示员工选择弹窗
  showGoonsDialog(row: any) {
    this.currentOrder = row
    this.goonsDialogVisible = true
    this.selectedGoons = null
    this.loadGoonsList()
  }

  // 加载员工列表
  async loadGoonsList() {
    try {
      const params = {
        page: 1,  // 页码从1开始
        pageSize: 100,
        isQuit: 0  // 只查询在职的员工
      }
      console.log('请求员工列表参数:', params)
      const res = await getGoonsList(params)
      if (res.data.code === 1) {
        this.goonsList = res.data.data.records || []
        console.log('加载到的员工列表:', this.goonsList) // 添加日志
        if (this.goonsList.length === 0) {
          this.$message.warning('没有找到可用的员工，请先在员工管理中添加员工')
        }
      } else {
        this.$message.error(res.data.msg || '获取员工列表失败')
      }
    } catch (err) {
      console.error('加载员工列表错误:', err) // 添加错误日志
      this.$message.error('请求出错了：' + err.message)
    }
  }

  // 选择员工
  handleSelectGoons(row) {
    this.selectedGoons = row
  }

  // 确认分配员工
  async confirmAssignGoons() {
    if (!this.selectedGoons || !this.currentOrder) {
      this.$message.warning('请选择一个员工')
      return
    }

    try {
      // 调用分配员工接口，只提交员工信息，状态变更由后端处理
      const params = {
        id: this.currentOrder.id,
        goonsId: this.selectedGoons.id,
        goonsName: this.selectedGoons.name
      }
      
      const res = await assignGoons(params)
      if (res.data.code === 1) {
        this.$message.success('接单成功')
        this.goonsDialogVisible = false
        this.dialogVisible = false
        this.init(this.orderStatus) // 刷新列表
      } else {
        this.$message.error(res.data.msg || '接单失败')
      }
    } catch (err) {
      this.$message.error('请求出错了：' + err.message)
    }
  }

  // 关闭员工选择弹窗
  handleGoonsDialogClose() {
    this.goonsDialogVisible = false
    this.selectedGoons = null
  }

  //打开拒单弹窗
  orderReject(row: any) {
    this.$confirm('确定要拒绝该订单吗?', '再次确认', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      orderReject({ id: row.id })
        .then((res) => {
          if (res.data.code === 1) {
            this.$message.success('操作成功')
            this.dialogVisible = false
            this.init(this.orderStatus)
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch((err) => {
          this.$message.error('请求出错了：' + err.message)
        })
    }).catch(() => {
      // 用户点击取消，不做操作
    })
  }

  //接单 - 保留原有方法以防其他地方调用
  orderAccept(row: any) {
    this.showGoonsDialog(row)
  }

  //打开取消订单弹窗
  cancelOrder(row: any) {
    this.$confirm('确定要取消该订单吗?', '再次确认', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      orderCancel({ id: row.id })
        .then((res) => {
          if (res.data.code === 1) {
            this.$message.success('操作成功')
            this.init(this.orderStatus)
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch((err) => {
          this.$message.error('请求出错了：' + err.message)
        })
    }).catch(() => {
      // 用户点击取消，不做操作
    })
  }

  // 派送，完成
  cancelOrDeliveryOrComplete(status: number, id: string) {
    // 根据当前状态调用不同的API
    // 状态为3（服务中）时调用delivery进入待结单
    // 状态为4（待结单）时调用complete完成订单
    const api = status === 3 ? deliveryOrder : completeOrder
    
    api({ id })
      .then((res) => {
        if (res.data.code === 1) {
          this.$message.success('操作成功')
          this.orderId = ''
          this.dialogVisible = false
          // 更新状态：服务中->待结单->已完成
          const newStatus = status === 3 ? 4 : 5
          this.init(newStatus)
          // 触发父组件更新订单统计
          this.$emit('getOrderListBy3Status')
        } else {
          this.$message.error(res.data.msg)
        }
      })
      .catch((err) => {
        this.$message.error('请求出错了：' + err.message)
      })
  }

  handleClose() {
    this.dialogVisible = false
  }

  private handleSizeChange(val: any) {
    this.pageSize = val
    this.init(this.orderStatus)
  }

  private handleCurrentChange(val: any) {
    this.page = val
    this.init(this.orderStatus)
  }

  private handleImageError(e) {
    // 替换图片错误事件
    e.target.style.display = 'none'
    const parent = e.target.parentNode
    if (parent && !parent.querySelector('.goods-image-error')) {
      const errorSpan = document.createElement('span')
      errorSpan.className = 'goods-image-error'
      errorSpan.textContent = '图片错误'
      parent.insertBefore(errorSpan, e.target.nextSibling)
    }
  }

  // 处理服务按钮点击
  private async handleDelivery(row: any) {
    try {
      const res = await deliveryOrder({ id: row.id })
      if (res.data.code === 1) {
        this.$message.success('操作成功')
        this.init(4) // 刷新待结单状态的订单列表
      } else {
        this.$message.error(res.data.msg)
      }
    } catch (err) {
      this.$message.error('操作失败：' + err.message)
    }
  }

  // 处理发放奖品
  private async handleGrantPrize(orderId: string) {
    try {
      // 确保有奖品订单ID
      if (!this.diaForm.prizeOrderId) {
        this.$message.error('未找到奖品订单信息')
        return
      }

      await this.$confirm('确定要发放该奖品吗?', '再次确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })

      const res = await deliverPrize(this.diaForm.prizeOrderId.toString())
      if (res.data.code === 1) {
        this.$message.success('奖品发放成功')
        this.goDetail(orderId, this.dialogOrderStatus)
      } else {
        this.$message.error(res.data.msg || '奖品发放失败')
      }
    } catch (err) {
      if (err === 'cancel') {
        console.log('用户取消操作')
      } else {
        this.$message.error('操作失败：' + err.message)
      }
    }
  }

  // 显示完成订单弹窗
  showCompleteDialog(row: any) {
    this.completeOrderData = row
    this.completeDialogVisible = true
  }

  // 关闭完成订单弹窗
  handleCompleteDialogClose() {
    this.completeDialogVisible = false
    this.completeOrderData = null
  }

  // 确认完成订单
  async confirmCompleteOrder(orderId: string) {
    try {
      await this.$confirm('确定要完成该订单吗?', '再次确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })

      const res = await completeOrder({ id: orderId })
      if (res.data.code === 1) {
        this.$message.success('订单完成成功')
        this.completeDialogVisible = false
        this.completeOrderData = null
        // 刷新待结单订单列表
        this.init(4)
      } else {
        this.$message.error(res.data.msg || '订单完成失败')
      }
    } catch (err) {
      if (err === 'cancel') {
        console.log('用户取消操作')
      } else {
        this.$message.error('操作失败：' + err.message)
      }
    }
  }

  // 驳回订单
  async rejectOrder(order: any) {
    try {
      await this.$confirm('确定要驳回该订单吗？订单将回到服务中状态，等待打手重新提交凭证。', '再次确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })

      // 这里需要调用驳回订单的API，后续添加
      // 暂时使用现有的接口，将订单状态改回服务中
      const res = await this.rejectOrderRequest(order.id)
      if (res.data.code === 1) {
        this.$message.success('订单驳回成功')
        this.completeDialogVisible = false
        this.completeOrderData = null
        // 刷新待结单订单列表
        this.init(4)
      } else {
        this.$message.error(res.data.msg || '订单驳回失败')
      }
    } catch (err) {
      if (err === 'cancel') {
        console.log('用户取消操作')
      } else {
        this.$message.error('操作失败：' + err.message)
      }
    }
  }

  // 驳回订单API调用
  async rejectOrderRequest(orderId: string) {
    return rejectOrder({ id: orderId })
  }
}
